import React from 'react';

interface VolatilityTableProps {
    rows: any[];
    theme: any;
}

export const VolatilityTable: React.FC<VolatilityTableProps> = ({ rows, theme }) => {
    // Sort by volatility descending and take top 10
    const topVolatile = [...rows]
        .filter(r => r.vol30 != null)
        .sort((a, b) => (b.vol30 ?? 0) - (a.vol30 ?? 0))
        .slice(0, 10);

    return (
        <div style={{ height: '100%', overflow: 'auto' }}>
            <table className='data-table' style={{ width: '100%' }}>
                <thead>
                    <tr>
                        <th className='left' style={{ color: theme.sub }}>Symbole</th>
                        <th className='left' style={{ color: theme.sub }}>Nom</th>
                        <th className='right' style={{ color: theme.sub }}>Volatilité</th>
                    </tr>
                </thead>
                <tbody>
                    {topVolatile.map((s) => (
                        <tr key={s.symbole}>
                            <td className='left' style={{ color: theme.text, fontWeight: 'bold' }}>
                                {s.symbole}
                            </td>
                            <td className='left' style={{ color: theme.sub, fontSize: 12 }}>
                                {s.nom}
                            </td>
                            <td className='right' style={{
                                color: '#FF6D00',
                                fontWeight: 'bold'
                            }}>
                                {((s.vol30 ?? 0) * 100).toFixed(2)}%
                            </td>
                        </tr>
                    ))}
                    {topVolatile.length === 0 && (
                        <tr>
                            <td colSpan={3} style={{ textAlign: 'center', color: theme.sub, padding: 20 }}>
                                Aucune donnée disponible
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};
